module.exports = __webpack_public_path__ + "static/chat-b9354d7dff6283e353d522b29a626378.png";